/**
 * German translations
 */
export default {
    // Auth
    'auth.sign_in': 'Anmelden',
    'auth.sign_in_to': 'Bei {app} anmelden',
    'auth.enter_email_to_continue': 'Gib deine E-Mail-Adresse ein, um fortzufahren',
    'auth.email_label': 'E-Mail-Adresse',
    'auth.email_placeholder': 'you@example.com',
    'auth.continue': 'Weiter',
    'auth.checking': 'Überprüfen...',
    'auth.sign_out': 'Abmelden',
    'auth.signing_in': 'Anmeldung...',
    'auth.signed_in_redirecting': 'Erfolgreich angemeldet! Weiterleitung...',
    'auth.signed_in_close_tab': 'Erfolgreich angemeldet! Du kannst diesen Tab schliessen.',
    'auth.check_email': 'Prüfe deine E-Mails',
    'auth.sign_in_link_sent': 'Wir haben einen Anmeldelink an {email} gesendet',
    'auth.click_link_to_continue': 'Klicke auf den Link, um fortzufahren',
    'auth.first_signup_approval': 'Wenn du dich zum ersten Mal anmeldest, muss deine Anfrage möglicherweise genehmigt werden, bevor wir den Anmeldelink senden.',
    'auth.didnt_receive_try_again': 'Nicht erhalten? Erneut versuchen',
    'auth.click_link_to_sign_in': 'Klicke auf den Link in der E-Mail, um dich anzumelden.',
    'auth.resend_email': 'E-Mail erneut senden',
    'auth.use_different_email': 'Andere E-Mail verwenden',
    'auth.passkey_available': 'Passkey verfügbar',
    'auth.sign_in_with_passkey': 'Mit Passkey anmelden',
    'auth.security_key_required': 'Sicherheitsschlüssel erforderlich',
    'auth.use_security_key_to_sign_in': 'Verwende deinen Sicherheitsschlüssel, um dich bei {email} anzumelden',
    'auth.sign_in_with_security_key': 'Mit Sicherheitsschlüssel anmelden',
    'auth.waiting_for_device': 'Warte auf Gerät...',
    'auth.verifying': 'Überprüfen...',
    'auth.lost_device_access': 'Keinen Zugriff mehr auf dein Gerät?',
    'auth.lost_security_key_access': 'Keinen Zugriff mehr auf deinen Sicherheitsschlüssel?',
    'auth.link_opened_different_device': 'Link auf einem anderen Gerät geöffnet',
    'auth.enter_verification_code': 'Gib den dort angezeigten Bestätigungscode ein:',
    'auth.verify_code': 'Code überprüfen',
    'auth.please_enter_email': 'Bitte gib deine E-Mail-Adresse ein',
    'auth.please_enter_valid_email': 'Bitte gib eine gültige E-Mail-Adresse ein',
    'auth.please_enter_6_digit_code': 'Bitte gib den 6-stelligen Code ein',
    'auth.please_enter_valid_6_digit_code': 'Bitte gib einen gültigen 6-stelligen Code ein',
    'auth.session_expired': 'Sitzung abgelaufen. Bitte versuche es erneut.',
    'auth.session_expired_request_new': 'Sitzung abgelaufen. Bitte fordere einen neuen Anmeldelink an.',
    'auth.signin_replaced': 'Diese Anmeldung wurde durch eine neuere Anfrage ersetzt. Bitte prüfe deine E-Mails.',
    'auth.authentication_failed': 'Authentifizierung fehlgeschlagen. Bitte versuche es erneut.',
    'auth.failed_send_link': 'Anmeldelink konnte nicht gesendet werden. Bitte versuche es erneut.',
    'auth.failed_verify_code': 'Code konnte nicht überprüft werden. Bitte versuche es erneut.',
    'auth.webauthn_not_supported': 'Sicherheitsschlüssel werden in diesem Browser nicht unterstützt',
    'auth.unexpected_error': 'Ein unerwarteter Fehler ist aufgetreten. Bitte versuche es erneut.',
    'auth.invalid_or_missing_token': 'Ungültiges oder fehlendes Verifizierungstoken',
    'auth.verification_failed': 'Verifizierung fehlgeschlagen. Bitte versuche es erneut.',
    'auth.keep_signed_in_question': 'Angemeldet bleiben?',
    'auth.keep_signed_in_description': 'An einem geteilten oder \u00f6ffentlichen Computer w\u00e4hle \u201eNicht jetzt\u201c \u2014 deine Sitzung endet nach 30 Minuten Inaktivit\u00e4t.',
    'auth.keep_signed_in_yes': 'Angemeldet bleiben',
    'auth.keep_signed_in_no': 'Nicht jetzt',

    // Settings
    'settings.title': 'Einstellungen',
    'settings.profile': 'Profil',
    'settings.profile_display_name': 'Anzeigename',
    'settings.profile_display_name_placeholder': 'Gib deinen Namen ein',
    'settings.profile_display_name_help': 'Dieser Name wird anstelle deiner E-Mail angezeigt',
    'settings.profile_not_set': 'Nicht festgelegt',
    'settings.profile_avatar': 'Avatar',
    'settings.profile_avatar_upload': 'Hochladen',
    'settings.profile_avatar_help': 'JPG, PNG, GIF oder WebP. Max 2 MB.',
    'settings.profile_avatar_too_large': 'Die Datei darf maximal 2 MB gross sein',
    'settings.profile_avatar_invalid_type': 'Die Datei muss JPG, PNG, GIF oder WebP sein',
    'settings.profile_avatar_updated': 'Avatar aktualisiert',
    'settings.profile_avatar_removed': 'Avatar entfernt',
    'settings.profile_avatar_remove_confirm': 'Avatar entfernen?',
    'settings.profile_timezone': 'Zeitzone',
    'settings.profile_timezone_select': 'Zeitzone wählen',
    'settings.profile_timezone_search': 'Zeitzonen suchen...',
    'settings.profile_updated': 'Profil aktualisiert',
    'settings.language': 'Sprache',
    'settings.language_description': 'Wähle deine bevorzugte Sprache',
    'settings.sessions': 'Sitzungen',
    'settings.sessions_description': 'Verwalte deine aktiven Sitzungen',
    'settings.security': 'Sicherheit',
    'settings.security_description': 'Verwalte deine Sicherheitsschlüssel und Passkeys',

    // Dashboard
    'dashboard.title': 'Dashboard',
    'dashboard.welcome': 'Willkommen, {name}',
    'dashboard.edit_profile': 'Profil bearbeiten',
    'dashboard.member_since': 'Mitglied seit {date}',
    'dashboard.services': 'Dienste',
    'dashboard.account': 'Konto',
    'dashboard.organizations_title': 'Organisationen',
    'dashboard.organizations_description': 'Verwalte deine Organisationen',
    'dashboard.domains_title': 'Domains',
    'dashboard.domains_description': 'Domains und DNS konfigurieren',
    'dashboard.mailboxes_title': 'Postfächer',
    'dashboard.mailboxes_description': 'E-Mail-Konten und Speicher',
    'dashboard.aliases_title': 'Aliase',
    'dashboard.aliases_description': 'E-Mail-Weiterleitungen',
    'dashboard.settings_title': 'Einstellungen',
    'dashboard.settings_description': 'Profil und Sicherheit',
    'dashboard.support_title': 'Support',
    'dashboard.support_description': 'Support kontaktieren',

    // Support
    'support.title': 'Support',
    'support.description': 'Hast du eine Frage oder brauchst Hilfe? Schreib uns eine Nachricht und wir antworten an {email}. Falls du unter einer anderen Adresse erreichbar bist oder einen Rückruf wünschst, gib das bitte in deiner Nachricht an.',
    'support.organization': 'Organisation',
    'support.no_organization': 'Allgemeine Anfrage (keine Organisation)',
    'support.organization_help': 'Optional. Wähle aus, wenn deine Anfrage eine bestimmte Organisation betrifft.',
    'support.subject': 'Betreff',
    'support.message': 'Nachricht',
    'support.message_placeholder': 'Beschreibe deine Frage oder dein Anliegen...',
    'support.send': 'Senden',
    'support.sending': 'Wird gesendet...',
    'support.sent': 'Nachricht gesendet',
    'support.sent_description': 'Wir haben deine Nachricht erhalten und melden uns bei dir.',
    'support.send_another': 'Weitere Nachricht senden',
    'support.fields_required': 'Betreff und Nachricht sind erforderlich.',
    'support.send_error': 'Nachricht konnte nicht gesendet werden. Bitte versuche es erneut.',

    // Common
    'common.save': 'Speichern',
    'common.cancel': 'Abbrechen',
    'common.delete': 'Löschen',
    'common.edit': 'Bearbeiten',
    'common.add': 'Hinzufügen',
    'common.remove': 'Entfernen',
    'common.confirm': 'Bestätigen',
    'common.ok': 'OK',
    'common.close': 'Schliessen',
    'common.back': 'Zurück',
    'common.next': 'Weiter',
    'common.loading': 'Wird geladen...',
    'common.error': 'Fehler',
    'common.success': 'Erfolg',

    // Errors
    'error.generic': 'Etwas ist schiefgelaufen. Bitte versuche es erneut.',
    'error.network': 'Netzwerkfehler. Bitte überprüfe deine Verbindung.',
    'error.unauthorized': 'Du bist nicht berechtigt, diese Aktion durchzuführen.',
    'error.not_found': 'Die angeforderte Ressource wurde nicht gefunden.',

    // Admin forward conversion
    "admin.forward_conversion.title": "Weiterleitung in Mailbox-Alias umwandeln",
    "admin.forward_conversion.button": "Umwandeln",
    "admin.forward_conversion.description": "Wandle eine Weiterleitung in einen Mailbox-Alias um, wenn ihr Ziel eine aktive Mailbox dieser Organisation ist. Die Adresse und ihr Verlauf bleiben erhalten.",
    "admin.forward_conversion.empty": "Keine passenden Weiterleitungen. Das Ziel muss eine aktive Mailbox dieser Organisation sein, und für dieselbe Adresse darf noch kein Alias zu dieser Mailbox bestehen.",
    "admin.forward_conversion.search": "Adressen suchen...",
    "admin.forward_conversion.confirm": "{email} in einen Mailbox-Alias für {destination} umwandeln? Der Alias bleibt mit dieser Mailbox verbunden, wenn sich ihre E-Mail-Adresse ändert.",
    "admin.forward_conversion.success": "Weiterleitung in Mailbox-Alias umgewandelt",
    "admin.forward_conversion.failed": "Umwandlung fehlgeschlagen",
    "admin.forward_conversion.stale": "Diese Weiterleitung kann nicht mehr umgewandelt werden. Lade die Domainseite neu.",
    "admin.forward_conversion.invalid": "address_id und mailbox_id müssen positive ganze Zahlen sein",
    "admin.forward_conversion.event": "Weiterleitung in Mailbox-Alias umgewandelt",
} as const;
